import { render, staticRenderFns } from "./DataScreen copy.vue?vue&type=template&id=2cf89c20&scoped=true"
import script from "./DataScreen copy.vue?vue&type=script&lang=js"
export * from "./DataScreen copy.vue?vue&type=script&lang=js"
import style0 from "./DataScreen copy.vue?vue&type=style&index=0&id=2cf89c20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf89c20",
  null
  
)

export default component.exports